import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedAuthRoute = ({ children, redirectPath = '/' }) => {
  const { user } = useSelector((state) => state.Auth);

  // Check user & its permission
  if (user?.data) {
    const redirectPath = user?.data?.permission === 1 || user?.data?.permission === 2 ? '/user-dashboard' : user?.data?.permission === 0 ? '/admin-dashboard' : '/404';

    return <Navigate to={redirectPath} replace />;
  }

  return children || <Outlet />;
};

export default ProtectedAuthRoute;
